/* import __COLOCATED_TEMPLATE__ from './square-stand.hbs.js'; */
import Component from '@glimmer/component';
export default class SquareStand extends Component {
  // Use ...attributes instead of args for SVG specific properties, ex: height
  get fill() {
    return this.args.fill || 'var(--core-text-10-light-mode-color)';
  }
  get height() {
    return this.args.height || '24';
  }
  get width() {
    return this.args.width || '24';
  }
}